import { render, staticRenderFns } from "./CreateSubCategoryAdmin.vue?vue&type=template&id=3b28f1d4&"
import script from "./CreateSubCategoryAdmin.vue?vue&type=script&lang=js&"
export * from "./CreateSubCategoryAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports